<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationCriteresQualiopi'
});
</script>
<template>
  <ka-container
    code="p-formation-criteres-qualiopi"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Deroule -->
    <ka-container
      code="deroule"
      :options="{
        click: componentInstance.derouleClick,
        $state: { selected: $isEqual(componentInstance.$elements['part-2']?.style.hidden, componentInstance.$constants.part2Hidden) }
      }"
      :selected="{ click: componentInstance.derouleClickWhenSelected }">
      <!-- placement -->
      <ka-container code="placement">
        <ka-text code="en-savoir">
          <h3 v-html="t('pFormationCriteresQualiopi.deroule.placement.enSavoir.value', `En savoir +`)" />
        </ka-text>
        <ka-icon
          code="icone-developper-1"
          :options="{ $inheritState: { selected: true } }"
          value="i-fa-solid:angle-down" />
      </ka-container>
    </ka-container>
    <!-- Part2 -->
    <ka-container
      code="part-2"
      :options="{
        style: { hidden: null },
        hidden: null
      }">
      <!-- Ligne -->
      <ka-container code="ligne" />
      <!-- Critères Qualiop -->
      <ka-container code="criteres-qualiop">
        <!-- Container1 -->
        <ka-container code="container-1">
          <ka-text code="accessibilite-handicap">
            <span v-html="t('pFormationCriteresQualiopi.part2.criteresQualiop.container1.accessibiliteHandicap.value', `<strong>Accessibilité handicap :</strong><br> <br>Nos formations peuvent s'adapter en fonction de votre handicap, contactez nous.`)" />
          </ka-text>
        </ka-container>
        <!-- Container1 -->
        <ka-container code="container-2">
          <ka-text code="methodes-pedagogiques">
            <span v-html="t('pFormationCriteresQualiopi.part2.criteresQualiop.container2.methodesPedagogiques.value', `<strong>Méthodes pédagogiques :</strong><br> <p><ul><li>Exposé suivi questions-réponses.</li><li>Analyse des acquis par le formateur.</li><li>Remise d'un support pédagogique.</li></ul><p> </p>`)" />
          </ka-text>
        </ka-container>
        <!-- Container1 -->
        <ka-container code="container-3">
          <ka-text code="modalites-et-delai">
            <span v-html="t('pFormationCriteresQualiopi.part2.criteresQualiop.container3.modalitesEtDelai.value', `<p><strong>Modalités et délai d'accès :</strong></p><p> </p><ul><li>Accompagnement disponible toute l'année sur demande. </li><li>Calendrier décidé conjointement selon votre besoin et la disponibilité de nos experts.</li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Container1 -->
        <ka-container code="container-4">
          <ka-text code="modalites-tarifaires">
            <span v-html="t('pFormationCriteresQualiopi.part2.criteresQualiop.container4.modalitesTarifaires.value', `<p><strong>Modalités tarifaires :</strong></p><p> </p><ul><li>À partir de 100€/h HT, ce prix est indicatif. L'équipe Matchers peut effectuer un devis sur-mesure. Pour 98% des entreprises que nous accompagnons, nous arrivons à débloquer des financements qui leurs permettent de financer la formation.</li></ul>`)" />
          </ka-text>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationCriteresQualiopiComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c9')
const component = pFormationCriteresQualiopiComponent()
const componentInstance = component.newStoreInstance()
withDefaults(defineProps<{
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

syncComponentStore(componentInstance)
</script>
